import { ApiEnvironment } from '../../models/api-environment';

export class FleetEnvironment extends ApiEnvironment {
  get accountsFleetOnlyEnabledUrl() {
    return `${this.baseUrl}/api/assets/v1/accounts/fleetonlyenabled`;
  }

  get avoidFavorSetsUrl() {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets`;
  }

  get avoidFavorSetsDefaultIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/defaultids`;
  }

  get avoidFavorSetsVehiclesUrl() {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/vehicles`;
  }

  get avoidFavorSetsVehicleGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/vehicleGroups`;
  }

  avoidFavorSetsIdVehicleGroupsUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/${setId}/vehicleGroups`;
  }

  avoidFavorSetsIdDefaultUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/${setId}/default`;
  }

  avoidFavorSetsVehicleGroupsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/${setId}/vehicleGroups/combinedassignment`;
  }

  get avoidFavorSetsRouteModifiersUrl() {
    return `${this.baseUrl}/api/assets/v1/avoidFavorSets/routeModifiers`;
  }

  get companyContactInfoUrl() {
    return `${this.baseUrl}/api/assets/v1/company/contactinfo`;
  }

  get companyConnectionSettingsUrl() {
    return `${this.baseUrl}/api/assets/v1/company/connectionSettings`;
  }

  get companyCredentialRegisterUrl() {
    return `${this.baseUrl}/api/assets/v1/company/credential/register`;
  }

  get companyDevicesInformationUrl() {
    return `${this.baseUrl}/api/assets/v1/company/devices/information`;
  }

  get companyDataShareSettingsUrl() {
    return `${this.baseUrl}/api/assets/v1/company/dataShareSettings`;
  }

  get companyFleetsOrphanUrl() {
    return `${this.baseUrl}/api/assets/v1/company/fleets/orphan`;
  }

  get companyImportStatusUrl() {
    return `${this.baseUrl}/api/assets/v1/company/importstatus`;
  }

  get companyMapsetSettingsUrl() {
    return `${this.baseUrl}/api/assets/v1/company/mapsetSettings`;
  }

  get companyScheduleImportUrl() {
    return `${this.baseUrl}/api/assets/v1/company/scheduleimport`;
  }

  get companySyncAvailabilityStatusUrl() {
    return `${this.baseUrl}/api/assets/v1/company/sync/availabilitystatus`;
  }

  get companySyncStatusUrl() {
    return `${this.baseUrl}/api/assets/v1/company/syncStatus`;
  }

  get configurationProfilesUrl() {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles`;
  }

  get configurationProfilesDefaultIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/defaultids`;
  }

  configurationProfilesIdDefaultUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/${id}/default`;
  }

  configurationProfilesIdVehicleGroupsUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/${id}/vehicleGroups`;
  }

  configurationProfilesIdVehicleGroupsAssignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/${id}/vehicleGroups/assign`;
  }

  configurationProfilesIdVehicleGroupsUnassignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/${id}/vehicleGroups/unassign`;
  }

  configurationProfilesVehicleGroupsCombinedAssignmentUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/${id}/vehicleGroups/combinedassignment`;
  }

  get configurationProfilesVehicleGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/vehicleGroups`;
  }

  get configurationProfilesVehiclesUrl() {
    return `${this.baseUrl}/api/assets/v1/configurationProfiles/vehicles`;
  }

  get driverListUrl() {
    return `${this.baseUrl}/api/assets/v1/driverlist`;
  }

  get driversUrl() {
    return `${this.baseUrl}/api/assets/v1/drivers`;
  }

  driversDriverGroupsCombinedAssignmentUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/drivers/${encodeURIComponent(
      id
    )}/driverGroups/combinedassignment`;
  }

  get driversExportUrl() {
    return `${this.baseUrl}/api/assets/v1/drivers/export`;
  }

  get driversImportUrl() {
    return `${this.baseUrl}/api/assets/v1/drivers/import`;
  }

  get driversUpdateByIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/drivers/updatebyids`;
  }

  get driverGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/driverGroups`;
  }

  get driverGroupsDriversUrl() {
    return `${this.baseUrl}/api/assets/v1/driverGroups/drivers`;
  }

  driverGroupsDriversAssignUrl(driverGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/driverGroups/${driverGroupId}/drivers/assign`;
  }

  driverGroupsDriversIdUrl(driverId: string) {
    return `${
      this.baseUrl
    }/api/assets/v1/driverGroups/drivers/${encodeURIComponent(driverId)}`;
  }

  driverGroupsDriversUnassignUrl(driverGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/driverGroups/${driverGroupId}/drivers/unassign`;
  }

  get driversVehicleLinksUrl() {
    return `${this.baseUrl}/api/assets/v1/drivers/vehicle/links`;
  }

  get placeSetsUrl() {
    return `${this.baseUrl}/api/assets/v1/placeSets`;
  }

  get placeSetsDefaultIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/placeSets/defaultids`;
  }

  get placeSetsVehiclesUrl() {
    return `${this.baseUrl}/api/assets/v1/placeSets/vehicles`;
  }

  get placeSetsVehicleGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/placeSets/vehicleGroups`;
  }

  placeSetsVehicleGroupsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/placeSets/${setId}/vehicleGroups/combinedassignment`;
  }

  placeSetsIdVehicleGroupsUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/placeSets/${setId}/vehicleGroups`;
  }

  placeSetsIdDefaultUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/placeSets/${setId}/default`;
  }

  get placeSetsCustomPlacesUrl() {
    return `${this.baseUrl}/api/assets/v1/placeSets/customPlaces`;
  }

  get mapSetsUrl() {
    return `${this.baseUrl}/api/assets/v1/mapSets`;
  }

  get mapSetsAvailableRegionsUrl() {
    return `${this.baseUrl}/api/assets/v1/mapSets/availableRegions`;
  }

  mapSetsVehicleGroupsUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/mapSets/${id}/vehicleGroups/`;
  }

  mapSetsVehicleGroupsAssignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/mapSets/${id}/vehicleGroups/assign`;
  }

  mapSetsVehicleGroupsAssignmentUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/mapSets/${id}/vehicleGroups/assignment`;
  }

  mapSetsVehicleGroupsUnassignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/mapSets/${id}/vehicleGroups/unassign`;
  }

  get mapSetsDefaultIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/mapSets/defaultids`;
  }

  routingProfileVehicleGroupsUrl(routingProfileId: number) {
    return `${this.baseUrl}/api/assets/v1/routingProfile/${routingProfileId}/vehicleGroups`;
  }

  routingProfileVehicleGroupsAssignUrl(routingProfileId: number) {
    return `${this.baseUrl}/api/assets/v1/routingProfile/${routingProfileId}/vehicleGroups/assign`;
  }

  routingProfileVehicleGroupsUnassignUrl(routingProfileId: number) {
    return `${this.baseUrl}/api/assets/v1/routingProfile/${routingProfileId}/vehicleGroups/unassign`;
  }

  get speedCoachingUrl() {
    return `${this.baseUrl}/api/assets/v1/speedCoaching`;
  }

  get speedCoachingDefaultUrl() {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/default`;
  }

  speedCoachingIdDefaultUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/${id}/default`;
  }

  speedCoachingIdVehicleGroupsUrl(speedCoachingProfileId: number) {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/${speedCoachingProfileId}/vehicleGroups`;
  }

  speedCoachingVehicleGroupsCombinedAssignmentUrl(
    speedCoachingProfileId: string
  ) {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/${speedCoachingProfileId}/vehicleGroups/combinedAssignment`;
  }

  get speedCoachingDefaultIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/defaultids`;
  }

  get speedCoachingVehicleGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/vehicleGroups`;
  }

  speedCoachingIdVehicleGroupsAssignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/${id}/vehicleGroups/assign`;
  }

  speedCoachingIdVehicleGroupsUnassignUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/${id}/vehicleGroups/unassign`;
  }

  get speedCoachingVehiclesUrl() {
    return `${this.baseUrl}/api/assets/v1/speedCoaching/vehicles`;
  }

  get vehiclesUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles`;
  }

  get vehiclesDriverLinksUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/driver/links`;
  }

  vehiclesIdGroupsUrl(vehicleId: string) {
    return `${this.baseUrl}/api/assets/v1/vehicles/${vehicleId}/groups`;
  }

  get vehiclesImportUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/import`;
  }

  get vehiclesExportUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/export`;
  }

  get vehiclesUpdateByIdsUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/updatebyids`;
  }

  get vehicleGroupsUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups`;
  }

  get vehicleGroupsAllVehiclesGroupUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/allvehiclesgroup`;
  }

  vehicleGroupsAccountUrl(accountAlias: string) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/account/${accountAlias}`;
  }

  globalVehicleSearchUrl(vehicleSearchValue: string) {
    return `${this.baseUrl}/api/assets/v1/vehicles/global/search/${vehicleSearchValue}`;
  }

  get vehiclesSearchUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/search`;
  }

  vehicleGroupsAvoidFavorSetsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${setId}/avoidFavorSets/combinedassignment`;
  }

  vehicleGroupsCustomPlaceSetsCombinedAssignmentUrl(setId: number) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${setId}/customPlaceSets/combinedassignment`;
  }

  vehicleGroupsIdMapsetsUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${vehicleGroupId}/mapsets`;
  }

  vehicleGroupsIdRoutingProfilesUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${vehicleGroupId}/routingProfiles`;
  }

  vehicleGroupsIdRoutingProfilesCombinedAssignmentUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${vehicleGroupId}/routingProfiles/combinedAssignment`;
  }

  vehicleGroupsIdVehiclesUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${id}/vehicles`;
  }

  vehicleGroupsVehiclesCombinedAssignmentUrl(vehicleGroupId: string) {
    return `${this.baseUrl}/api/assets/v1/vehicleGroups/${vehicleGroupId}/vehicles/combinedAssignment`;
  }

  vehiclesVehicleGroupsCombinedAssignmentUrl(id: number) {
    return `${this.baseUrl}/api/assets/v1/vehicles/${id}/vehicleGroups/combinedassignment`;
  }

  get webAuthenticateUrl() {
    return `${this.baseUrl}/api/assets/v1/accounts/webAuthenticate`;
  }

  vehiclesAccountIdUrl(accountId: number) {
    return `${this.baseUrl}/api/assets/v1/vehicles/account/${accountId}`;
  }

  get vehiclesMoveUrl() {
    return `${this.baseUrl}/api/assets/v1/vehicles/move`;
  }

  get preferencesAccountUrl() {
    return `${this.baseUrl}/api/assets/v1/preferences/account`;
  }

  get preferencesfuellocationsUrl() {
    return `${this.baseUrl}/api/assets/v1/preferences/fuellocations`;
  }

  get preferencesReststoplocationsUrl() {
    return `${this.baseUrl}/api/assets/v1/preferences/reststoplocations`;
  }

  override resolve(environment: unknown) {
    return environment instanceof FleetEnvironment ? environment : this;
  }
}

export const fleetEnvironment = new FleetEnvironment();
